import api from "../utils/axios";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";

const ADMIN_OVERRIDES_KEY = ["adminOverrides"];

// GET all overrides (optional ?propertyId= &type= filters)
export const useAdminOverridesQuery = (filters = {}, options = {}) => {
  const { propertyId, type } = filters;
  return useQuery({
    queryKey: [...ADMIN_OVERRIDES_KEY, { propertyId, type }],
    queryFn: async () => {
      const params = new URLSearchParams();
      if (propertyId) params.append("propertyId", propertyId);
      if (type) params.append("type", type);
      const qs = params.toString() ? `?${params.toString()}` : "";
      const res = await api.get(`/admin/adminOverride${qs}`);
      return res.data?.data || [];
    },
    ...options,
  });
};

// GET single override by ID
export const useAdminOverrideByIdQuery = (id, options = {}) => {
  return useQuery({
    queryKey: [...ADMIN_OVERRIDES_KEY, id],
    queryFn: async () => {
      const res = await api.get(`/admin/adminOverride/${id}`);
      return res.data?.data || null;
    },
    enabled: !!id,
    ...options,
  });
};

// CREATE override
export const useAddAdminOverrideMutation = (options = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data) => {
      const res = await api.post("/admin/adminOverride", data);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ADMIN_OVERRIDES_KEY });
    },
    ...options,
  });
};

// UPDATE override
export const useUpdateAdminOverrideMutation = (options = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, ...data }) => {
      const res = await api.put(`/admin/adminOverride/${id}`, data);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ADMIN_OVERRIDES_KEY });
    },
    ...options,
  });
};

// DELETE override
export const useDeleteAdminOverrideMutation = (options = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id) => {
      const res = await api.delete(`/admin/adminOverride/${id}`);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ADMIN_OVERRIDES_KEY });
    },
    ...options,
  });
};